module.exports = __webpack_public_path__ + "static/img/about.0b221e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about.png
// module id = 9tjY
// module chunks = 1